const subjects = {
  NOTIFY_INTEREST: 'NOTIFY_INTEREST',
  REGISTER_INTEREST: 'REGISTER_INTEREST',
  UNREGISTER_INTEREST: 'UNREGISTER_INTEREST',
  RAISE_INTENT: 'RAISE_INTENT',
  REGISTER_INTENT: 'REGISTER_INTENT',
  UNREGISTER_INTENT: 'UNREGISTER_INTENT',
  INTENT_ACTION: 'INTENT_ACTION',
  GET_CLIENT_DETALS: 'GET_CLIENT_DETALS',
  LAUNCH_PWA: 'LAUNCH_PWA',
  LIST_PWAS: 'LIST_PWAS',
  LIST_PWAS_RESP: 'LIST_PWAS_RESP',
  REGISTER_APP: 'REGISTER_APP',
  GET_LAUNCH_CONFIG: 'GET_LAUNCH_CONFIG',
  GET_LAUNCH_CONFIG_RESP: 'GET_LAUNCH_CONFIG_RESP',
};

export default subjects;
